module.exports = __webpack_public_path__ + "static/media/Rubik-Light.e53db673.eot";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/Rubik-Light/Rubik-Light.eot
// module id = 1300
// module chunks = 49